module.exports = __webpack_public_path__ + "img/Icon-survey-Calendar-disabled.e139cc7e.svg";